<template>
    <div>
        <vue-loading :loading="isLoading"></vue-loading>
        <vue-modal
            v-model="visible"
            v-if="visible && imagePlans"
            :header="true"
            title="Image Pricing"
            :modalBodyClass="$prefixClass.modal + '-more-images'"
        >
            <div class="image-quantity text-center">
                <span>Choose image quantity you want to buy</span>
                    <div class="m-t-12">
                        <a-radio-group v-model="planSelected">
                            <template v-for="(plan, index) in imagePlans">
                                <div :key="index" class="d-flex">
                                    <div :class="['display-space-between align-items-center radio-wapper', index != planKeys[planKeys.length - 1] ? 'm-b-16' : '']" >
                                        <a-radio :value="plan"> {{plan.title}} </a-radio>
                                        <span>{{ formatPrice(plan.price, 1) }}</span>
                                    </div>
                                    <a-badge v-if="plan.saving" :class="['m-l-8', index == planKeys[planKeys.length - 1] ? 'success' : '']">Save {{ plan.saving }}%</a-badge>
                                </div>
                            </template>
                        </a-radio-group>
                    </div>
            </div>
            <template slot="footer">
                <a-button class="m-r-8" type="secondary" @click="visible = false"> {{$t('app.buttons.cancel')}} </a-button>
                <a-button type="primary" @click="doBuyMoreImages"> {{$t('app.buttons.buy_now')}} </a-button>
            </template>
        </vue-modal>
    </div>
</template>
<script>
import { mapActions, mapGetters  } from 'vuex'
import { types as typesCharge } from '@/modules/charge/constant'
import cookie from 'js-cookie'
export default {
    name: 'VueModalBuyMoreImages',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        optimizeSettings: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            isLoading: false,
            planSelected: null,
            planKeys: []
        }
    },
    computed: {
        ...mapGetters({
            imagePlans: typesCharge.getters.GET_IMAGE_PLANS
        }),
        visible: {
            get() {
                return this.value
            },
            set( value ) {
                this.$emit('input', value)
            }
        }
    },
    watch: {
        visible: {
            handler( value ) {
                if ( value ) {
                    this.planSelected = this.imagePlans[this.planKeys[0]]
                }
            },
            deep: true
        }
    },
    created() {
        this.planKeys =  Object.keys(this.imagePlans)
        this.$set(this.imagePlans[this.planKeys[1]], 'saving', 10)
        this.$set(this.imagePlans[this.planKeys[2]], 'saving', 15)
        this.planSelected = this.imagePlans[this.planKeys[0]]
    },
    methods: {
        ...mapActions({
            getImagePlans: typesCharge.actions.GET_IMAGE_PLANS,
            buyMoreImages: typesCharge.actions.BUY_MORE_IMAGES
        }),
        async doBuyMoreImages() {
            let self = this
            this.isLoading = true
            this.visible = false
            if ( this.optimizeSettings && (this.optimizeSettings.optimize_image || this.optimizeSettings.optimize_theme) ) {
                cookie.set( 'optimize_settings' , this.optimizeSettings , { 
                    expires: 1
                })
            } else {
                cookie.remove('optimize_settings')
            }
            let path = window.location.href.split('?')[0]+"?image_plan_name="+this.planSelected.name
            await this.buyMoreImages({plan: this.planSelected.name, url_redirect: path}).then(res => {
                let { status = false, data = null, message} = res.data;
                if (status) {
                    if ( !cookie.get('show-bar-image-limit') ) {
                        cookie.set('show-bar-image-limit', true, { expires: 30 } )
                    }
                    window.location.href = data.redirect_url;
                } else {
                    self.toastError({
                        title: "Error",
                        message: self.$t('app.errors.something_went_wrong'),
                        duration: 4
                    })
                }
                self.isLoading = false
            })
            .catch(e => {
                self.isLoading = false
                console.log(e);
            });
        }
    }
}
</script>
<style lang="scss">
    .m-modal-more-images {
        .m-modal {
            &-body {
                padding: 16px;
                .a-radio-group {
                    margin-left: 65px;
                    .radio-wapper {
                        width: 220px;
                    }
                    .a-badge {
                        border-radius: 30px;
                        background: $primary-color-light;
                        border-color: $primary-color-light;
                        &.success {
                            background: $success-color;
                            border-color: $success-color;
                        }
                    }
                }
            }
            &-content {
                height: 296px;
            }
            &-footer {
                padding: 16px;
            }
        }
    }
</style>